import { resourceListBindings } from 'tmr/components/resourceList/resourceListHelper'
import templateUrl from './operationConfigurations.html'

/**
 * Operation Configuration route
 *
 * @namespace routes.AdminOperationConfigurations
 * @type {TmrRoute}
 */
export const route = {
  name: 'admin.settings.operationConfigurations.list',
  label: 'ADMIN.OPERATIONCONFIGURATIONS.TITLE',
  url: '/operations',
  component: 'tmrAdminOperationConfigurations',
  params: {
    orderBy: {
      value: 'CODE',
      squash: true,
    },
    asc: {
      value: true,
      type: 'bool',
      squash: true,
    },
  },
  resourceType: 'OperationConfiguration',
  resourceList: {
    searchParameters: ['operationType', 'client'],
  },
}

/**
 * @type {ngComponent}
 */
export const tmrAdminOperationConfigurations = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminOperationConfigurationsController',
  bindings: resourceListBindings(),
}

/**
 * @type {ngController}
 */
export class tmrAdminOperationConfigurationsController {
  static ngType = 'controller'

  constructor(tmrOperationConfigurationTypes) {
    'ngInject'
    Object.assign(this, { tmrOperationConfigurationTypes })
  }
}
